import React from "react";
import { DmsTextField, DmsCheckBox, DmsSelect, DmsTextFieldPhone, DmsTextFieldEmail, intl } from "dmsbasereact";
import { DmsAutocomplete } from "../DmsAutoComplete/DmsAutoComplete";
import { Grid, Box } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers';
import DmsDatePicker from "../DmsDatePicker/DmsDatePicker";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DmsSelectRGIssuingAgency from "../DmsSelectRGIssuingAgency/DmsSelectRGIssuingAgency";
import { DmsTextFieldCpf } from "../DmsTextFieldCpf/DmsTextFieldCpf";
import { DmsTextFieldCep } from "../DmsTextFieldCep";

export const TabResponsibleLegalCreate = ({
    responsibleCpfValue,
    setResponsibleCpfValue,
    responsibleCpfIsValid,
    setResponsibleCpfIsValid,
    responsibleBirthDate,
    setResponsibleBirthDate,
    sameAddressAsPatient,
    setSameAddressAsPatient,
    stateOptions,
    responsibleName,
    setResponsibleName,
    // Address fields
    responsibleZipCode,
    setResponsibleZipCode,
    responsibleCity,
    setResponsibleCity,
    responsibleState,
    setResponsibleState,
    responsibleAddress,
    setResponsibleAddress,
    responsibleAddressNumber,
    setResponsibleAddressNumber,
    responsiblePhone,
    setResponsiblePhone,
    responsibleEmail,
    setResponsibleEmail,
    responsibleRg,
    setResponsibleRg,
    responsibleRgIssuingAgency,
    setResponsibleRgIssuingAgency,
    // Field errors for validation
    fieldErrors = {},
}) => {

    const onChangeSameAddressCheckbox = (event) => {
        setSameAddressAsPatient(event.target.checked)
    }

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <DmsTextField
                        label={intl.get("Name").d("Name") + " *"}
                        fullWidth
                        value={responsibleName}
                        onChange={(e) => setResponsibleName(e.target.value)}
                        error={!!fieldErrors.responsibleName}
                        helperText={fieldErrors.responsibleName}
                    />
                </Grid>
                <Grid item xs={12}>
                    <DmsTextFieldCpf
                        fullWidth
                        value={responsibleCpfValue}
                        onChange={(e) => setResponsibleCpfValue(e.target.value)}
                        onValidationChange={(isValid) => setResponsibleCpfIsValid(isValid)}
                        label={intl.get("CPF").d("CPF") + " *"}
                        error={!!fieldErrors.responsibleCpf}
                        helperText={fieldErrors.responsibleCpf}
                    />
                </Grid>
                <Grid item xs={12}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DmsDatePicker
                            label={intl.get("BirthDate").d("Birth Date")}
                            value={responsibleBirthDate}
                            onChange={(newValue) => setResponsibleBirthDate(newValue)}
                            format="DD/MM/YYYY"
                            slotProps={{ textField: { fullWidth: true } }}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <DmsTextField
                        label={intl.get("RG").d("RG")}
                        fullWidth
                        value={responsibleRg}
                        onChange={(e) => setResponsibleRg(e.target.value)}
                        inputProps={{ maxLength: 20 }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <DmsSelectRGIssuingAgency
                        value={responsibleRgIssuingAgency}
                        onChange={(value) => setResponsibleRgIssuingAgency(value)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <DmsCheckBox
                        label={intl.get("SameAddressAsPatient").d("Same address as patient")}
                        checked={sameAddressAsPatient}
                        onChange={onChangeSameAddressCheckbox}
                    />
                </Grid>
                {!sameAddressAsPatient && (
                    <>
                        <Grid item xs={12}>
                            <DmsTextFieldCep
                                label={intl.get("CEP").d("Zip Code")}
                                fullWidth
                                value={responsibleZipCode}
                                onChange={(e) => setResponsibleZipCode(e.target.value)}
                                required
                                error={!!fieldErrors.responsibleZipCode}
                                helperText={fieldErrors.responsibleZipCode}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DmsTextField
                                label={intl.get("City").d("City")}
                                fullWidth
                                value={responsibleCity}
                                onChange={(e) => setResponsibleCity(e.target.value)}
                                required
                                error={!!fieldErrors.responsibleCity}
                                helperText={fieldErrors.responsibleCity}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DmsAutocomplete
                                options={stateOptions}
                                label={intl.get('State').d('State')}
                                value={responsibleState}
                                onChange={(value) => setResponsibleState(value)}
                                fullWidth
                                required
                                error={!!fieldErrors.responsibleState}
                                helperText={fieldErrors.responsibleState}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DmsTextField
                                label={intl.get("Address").d("Address")}
                                fullWidth
                                value={responsibleAddress}
                                onChange={(e) => setResponsibleAddress(e.target.value)}
                                required
                                error={!!fieldErrors.responsibleAddress}
                                helperText={fieldErrors.responsibleAddress}
                                inputProps={{ maxLength: 255 }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DmsTextField
                                label={intl.get("Number").d("Number")}
                                fullWidth
                                value={responsibleAddressNumber}
                                onChange={(e) => setResponsibleAddressNumber(e.target.value)}
                                required
                                error={!!fieldErrors.responsibleAddressNumber}
                                helperText={fieldErrors.responsibleAddressNumber}
                                inputProps={{ maxLength: 10 }}
                            />
                        </Grid>
                    </>
                )}
                <Grid item xs={12} sm={6}>
                    <DmsTextFieldPhone
                        fullWidth
                        label={intl.get("PhoneNumber").d("Phone Number")}
                        value={responsiblePhone}
                        onChange={(e) => setResponsiblePhone(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <DmsTextFieldEmail
                        fullWidth
                        value={responsibleEmail}
                        onChange={(e) => setResponsibleEmail(e.target.value)}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};
